<template>
  <div style="background: #163626">
    <success-snackbar
      v-if="showSuccessSnackbar"
      :snackbarText="snackbarText"
      @hidde="showSuccessSnackbar = false"
    />
    <v-main>
      <v-container>
        <div style="padding: 80px 0px 26px 0px">
          <h2 class="section-name" style="color: #ffffff">
            Kontakt & nächste Schritte
          </h2>
          <v-row no-gutters style="margin-top: 58px">
            <v-col
              cols="12"
              xl="6"
              lg="6"
              md="6"
              sm="12"
              :style="
                $vuetify.breakpoint.smAndDown ? '' : 'padding-right: 16px'
              "
            >
              <p
                style="
                  color: #ddae5a;
                  font-family: 'Julius Sans One';
                  font-size: 36.658px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: normal;
                  text-transform: uppercase;
                  margin-bottom: 32px;
                "
              >
                Vivamus Gmbh
              </p>
              <div class="contact-card">
                <v-row no-gutters>
                  <div class="contact-card-icon">
                    <img
                      src="@/assets/img/mapMarkerIcon.svg"
                      width="20px"
                      height="20px"
                      alt="icon"
                    />
                  </div>
                  <v-col class="px-0 py-0" style="margin-left: 16px">
                    <span>Adresse</span>
                    <p class="contact-card-text">Rathausgasse 31, 5000 Aarau</p>
                  </v-col>
                </v-row>
              </div>
              <div class="contact-card">
                <v-row no-gutters>
                  <div class="contact-card-icon">
                    <img
                      src="@/assets/img/phoneIcon.svg"
                      width="20px"
                      height="20px"
                      alt="icon"
                    />
                  </div>
                  <v-col class="px-0 py-0" style="margin-left: 16px">
                    <span>Telefon</span>
                    <a
                      class="contact-card-text"
                      href="tel:+41766418041"
                      style="text-decoration: none"
                    >
                      <p class="contact-card-text">+41 76 641 80 41</p>
                    </a>
                  </v-col>
                </v-row>
              </div>
              <div class="contact-card">
                <v-row no-gutters>
                  <div class="contact-card-icon">
                    <img
                      src="@/assets/img/mailIcon.svg"
                      width="20px"
                      height="20px"
                      alt="icon"
                    />
                  </div>
                  <v-col class="px-0 py-0" style="margin-left: 16px">
                    <span>E-Mail</span>
                    <a
                      class="contact-card-text"
                      href="mailto:office@vivamus.ch"
                      style="text-decoration: none"
                    >
                      <p class="contact-card-text">office@vivamus.ch</p>
                    </a>
                  </v-col>
                </v-row>
              </div>
              <!-- <div
                class="contact-card"
                :style="
                  $vuetify.breakpoint.smAndDown ? 'margin-bottom: 0px' : ''
                "
              >
                <v-row no-gutters>
                  <div class="contact-card-icon">
                    <img
                      src="@/assets/img/mapMarkerIcon.svg"
                      width="20px"
                      height="20px"
                      alt="icon"
                    />
                  </div>
                  <v-col class="px-0 py-0" style="margin-left: 16px">
                    <span>Website</span>
                    <a
                      class="contact-card-text"
                      href="https://vivamus.bmax.com.ua/"
                      style="text-decoration: none"
                    >
                      <p class="contact-card-text">
                        https://vivamus.bmax.com.ua/
                      </p>
                    </a>
                  </v-col>
                </v-row>
              </div> -->
            </v-col>
            <div v-if="$vuetify.breakpoint.smAndDown" style="margin: 24px 0px">
              <p class="social-icon-title">Wir freuen uns fon ihnen zu hören</p>
              <v-row no-gutters>
                <a href="https://www.instagram.com/vivamus.ch" target="_blank">
                  <img
                    src="@/assets/img/iconsSvg/instagramIcon.svg"
                    width="50px"
                    height="50px"
                    alt="instagram icon"
                    style="margin-right: 16px"
                  />
                </a>
                <a href="https://www.facebook.com/vivamus.ch" target="_blank">
                  <img
                    src="@/assets/img/iconsSvg/facebookIcon.svg"
                    width="50px"
                    height="50px"
                    alt="facebook icon"
                    style="margin-right: 16px"
                  />
                </a>
                <a href="https://www.twitter.com/vivamus.ch" target="_blank">
                  <img
                    src="@/assets/img/iconsSvg/twitterIcon.svg"
                    width="50px"
                    height="50px"
                    alt="twitter icon"
                    style="margin-right: 16px"
                  />
                </a>
              </v-row>
            </div>
            <v-col
              cols="12"
              xl="6"
              lg="6"
              md="6"
              sm="12"
              :style="$vuetify.breakpoint.smAndDown ? '' : 'padding-left: 16px'"
            >
              <div class="contact-form">
                <h4 class="contact-form-title">Kostenloses Erstgespräch</h4>
                <v-row no-gutters>
                  <v-col
                    cols="12"
                    xl="6"
                    lg="6"
                    md="6"
                    sm="12"
                    :style="
                      $vuetify.breakpoint.smAndDown ? '' : 'padding-right: 8px'
                    "
                  >
                    <p>Name *</p>
                    <v-text-field
                      outlined
                      dense
                      color="#163626"
                      style="border-radius: 8px"
                      height="40px"
                      background-color="#F8F6F2"
                      hide-details
                      v-model="message.name"
                      :error-messages="nameError"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    xl="6"
                    lg="6"
                    md="6"
                    sm="12"
                    :style="
                      $vuetify.breakpoint.smAndDown
                        ? 'margin-top: 16px'
                        : 'padding-left: 8px'
                    "
                  >
                    <p>Telefon</p>
                    <v-text-field
                      outlined
                      dense
                      color="#163626"
                      style="border-radius: 8px"
                      height="40px"
                      background-color="#F8F6F2"
                      hide-details
                      v-model="message.phone"
                      v-mask="'+## ### ## ## ## ##'"
                    />
                  </v-col>
                </v-row>
                <v-col cols="12" class="px-0 py-0" style="margin-top: 16px">
                  <p>E-Mail *</p>
                  <v-text-field
                    outlined
                    dense
                    color="#163626"
                    style="border-radius: 8px"
                    height="40px"
                    background-color="#F8F6F2"
                    hide-details
                    v-model="message.email"
                    :error-messages="emailError"
                  />
                </v-col>
                <v-col cols="12" class="px-0 py-0" style="margin-top: 16px">
                  <p>Nachricht</p>
                  <v-textarea
                    outlined
                    dense
                    color="#163626"
                    style="border-radius: 8px"
                    height="100px"
                    background-color="#F8F6F2"
                    placeholder="Beschreiben Sie kurz Ihr Anliegen..."
                    hide-details
                    v-model="message.text"
                    :error-messages="textError"
                  />
                </v-col>
                <v-btn
                  class="send-btn"
                  width="100%"
                  color="#C09559"
                  height="40px"
                  style="margin-top: 16px"
                  @click="sendMessage"
                >
                  <img
                    src="@/assets/img/sendIcon.svg"
                    width="16px"
                    height="16px"
                    alt="send icon"
                    style="margin-right: 16px"
                  />
                  Nachricht senden
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <div v-if="!$vuetify.breakpoint.smAndDown">
            <p class="social-icon-title">Wir freuen uns fon ihnen zu hören</p>
            <v-row no-gutters>
              <a
                :href="link.link"
                target="_blank"
                v-for="link in socialLinks"
                :key="link.id"
              >
                <img
                  :src="link.icon_url"
                  width="50px"
                  height="50px"
                  alt="instagram icon"
                  style="margin-right: 16px; object-fit: cover"
                />
              </a>
            </v-row>
          </div>
          <v-row no-gutters justify="center">
            <p class="welcome-text">
              Bereit für eine professionelle Partnerschaft? Kontaktieren Sie uns
              noch heute für ein unverbindliches Beratungsgespräch.
            </p>
          </v-row>
          <!-- <v-row no-gutters justify="center">
            <v-btn
              color="#C09559"
              class="btn-text"
              height="50px"
              :width="$vuetify.breakpoint.smAndDown ? '100%' : '280px'"
              style="color: #f8f6f2"
            >
              Jetzt Kontakt aufnehmen
            </v-btn>
            <v-btn
              color="#F8F6F2"
              class="btn-text"
              height="50px"
              style="color: #c09559"
              :style="
                $vuetify.breakpoint.smAndDown
                  ? 'margin-top: 16px; margin-left: 0px'
                  : 'margin-left: 16px'
              "
              :width="$vuetify.breakpoint.smAndDown ? '100%' : '240px'"
            >
              Rückruf vereinbaren
            </v-btn>
          </v-row> -->
        </div>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import feedbackService from "../../requests/Admin/feedbackService";
import SuccessSnackbar from "../UI/Snackbars/successSnackbar.vue";
import socialLinkService from "../../requests/Admin/socialLinkService";

export default {
  mixins: [validationMixin],
  components: {
    SuccessSnackbar,
  },
  data: () => ({
    message: {},
    socialLinks: [],
    snackbarText: "",
    showSuccessSnackbar: false,
  }),
  validations: {
    message: {
      name: {
        required,
      },
      email: {
        required,
        email,
      },
      text: {
        required,
      },
    },
  },
  mounted() {
    this.getSocialLinks();
  },
  methods: {
    async getSocialLinks() {
      await socialLinkService.getSocialLinks().then((response) => {
        this.socialLinks = response?.[0];
      });
    },
    async sendMessage() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const form = new FormData();
        form.append("name", this.message.name);
        form.append("email", this.message.email);
        form.append("user_message", this.message.text);
        if(this.message.phone){
          form.append("phone", this.message.phone.replace(/\D/g, ""));
        }
        // form.append("instagram_username", this.message.name);
        // form.append("telegram_username", this.message.name);
        await feedbackService.createFeedback(form).then(() => {
          this.snackbarText = "Nachricht gesendet";
          this.showSuccessSnackbar = true;
          this.message = {};
          this.$v.$reset();
        });
      }
    },
  },
  computed: {
    nameError() {
      const errors = [];
      if (!this.$v.message.name.$dirty) {
        return errors;
      } else if (!this.$v.message.name.required) {
        errors.push("");
      }
      return errors;
    },
    emailError() {
      const errors = [];
      if (!this.$v.message.email.$dirty) {
        return errors;
      } else if (!this.$v.message.email.required) {
        errors.push("");
      }
      if (!this.$v.message.email.email) {
        errors.push("");
      }
      return errors;
    },
    textError() {
      const errors = [];
      if (!this.$v.message.text.$dirty) {
        return errors;
      } else if (!this.$v.message.text.required) {
        errors.push("");
      }
      return errors;
    },
  },
};
</script>

<style scoped>
.contact-card {
  padding: 16px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(2px);
  color: rgba(255, 255, 255, 0.8);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  width: 100%;
  margin-bottom: 24px;
}
.contact-card-icon {
  border-radius: 8px;
  background: #c09559;
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
}
.contact-card-text {
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.contact-form {
  width: 100%;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 8px 10px -6px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(2px);
  color: #163626;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  padding: 32px;
}
.contact-form-title {
  color: #163626;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  margin-bottom: 12px;
}
.contact-form p {
  margin-bottom: 8px;
}
.send-btn {
  color: #f8f6f2;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  text-transform: none;
  border-radius: 6px !important;
}
.social-icon-title {
  color: #e3e0d9;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin-bottom: 14px;
}
.welcome-text {
  color: rgba(255, 255, 255, 0.9);
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin: 40px 0px 32px 0px;
  text-align: center;
}
.btn-text {
  color: #c09559;
  text-align: center;
  text-transform: none !important;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
}
</style>